import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Box, Button } from '@mui/material';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { ctxTargetAttributes } from '@/contexts/TargetAttributesContext';
import { TargetAttributesTabs } from './TargetAttributesPopup';
import { TargetAttributesTabValue } from '@/types';

export default function CategorySelector({ setActiveTab }: { setActiveTab: (tab: TargetAttributesTabs) => void }) {
  const { t } = useTranslation();

  const targetAttrCtx = useContext(ctxTargetAttributes);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        gap: 2,
        margin: '0% 8%',
      }}
    >
      <Stack spacing={2} mt={2} sx={{ width: '100%' }}>
        <Button
          className={`active-tab-selector target`}
          variant="outlined"
          color="primary"
          startIcon={<DirectionsCarOutlinedIcon />}
          fullWidth
          sx={{
            borderRadius: 5,
            justifyContent: 'center',
            textAlign: 'center',
            paddingRight: 0,
            pl: 2.5,
            '& .MuiButton-startIcon': {
              position: 'absolute',
              left: 16,
              margin: 0,
            },
          }}
          onClick={() => {
            setActiveTab('TargetTab');
            targetAttrCtx?.setTab(TargetAttributesTabValue.entitySelect);
          }}
          data-qa-element-id="select_vehicle_category_button"
        >
          {t('report.tab.target.title')}
        </Button>
        <Button
          className={`active-tab-selector driver`}
          variant="contained"
          color="secondary"
          fullWidth
          startIcon={<PersonOutlineOutlinedIcon />}
          sx={{
            borderRadius: 5,
            justifyContent: 'center',
            textAlign: 'center',
            paddingRight: 0,
            pl: 2.5,
            '& .MuiButton-startIcon': {
              position: 'absolute',
              left: 16,
              margin: 0,
            },
          }}
          onClick={() => {
            setActiveTab('DriverTab');
            targetAttrCtx?.setSelectedTargets([]);
            targetAttrCtx?.setTab(TargetAttributesTabValue.entitySelect);
          }}
          data-qa-element-id="select_driver_category_button"
        >
          {t('report.tab.driver.title')}
        </Button>
        <Button
          className={`active-tab-selector driver`}
          variant="contained"
          color="secondary"
          fullWidth
          startIcon={<PersonOutlineOutlinedIcon />}
          sx={{
            borderRadius: 5,
            justifyContent: 'center',
            textAlign: 'center',
            paddingRight: 0,
            pl: 2.5,
            '& .MuiButton-startIcon': {
              position: 'absolute',
              left: 16,
              margin: 0,
            },
          }}
          onClick={() => {
            setActiveTab('UsersTab');
            targetAttrCtx?.setSelectedTargets([]);
            targetAttrCtx?.setTab(TargetAttributesTabValue.entitySelect);
          }}
          data-qa-element-id="select_driver_category_button"
        >
          {t('report.tab.driver.title')}
        </Button>
      </Stack>
    </Box>
  );
}
